export enum UserAgreementType {
    PrivacyPolicy,
    TermsOfUse,
}
